var map = {
	"./AD.svg": "5428",
	"./AE.svg": "d62b",
	"./AF.svg": "6dab",
	"./AG.svg": "2271",
	"./AI.svg": "7fcc",
	"./AL.svg": "ed9c",
	"./AM.svg": "75f4",
	"./AO.svg": "16a8",
	"./AQ.svg": "8216",
	"./AR.svg": "51d5",
	"./AS.svg": "99c0",
	"./AT.svg": "ef51",
	"./AU.svg": "4b07",
	"./AW.svg": "f035",
	"./AX.svg": "3904",
	"./AZ.svg": "7097",
	"./BA.svg": "33f0",
	"./BB.svg": "e007",
	"./BD.svg": "873e",
	"./BE.svg": "ea09",
	"./BF.svg": "a10d",
	"./BG.svg": "3e90",
	"./BH.svg": "bf32",
	"./BI.svg": "3e6e",
	"./BJ.svg": "7778",
	"./BL.svg": "3c19",
	"./BM.svg": "b674",
	"./BN.svg": "94d2",
	"./BO.svg": "d96b",
	"./BQ.svg": "7d52",
	"./BR.svg": "4675",
	"./BS.svg": "4a73",
	"./BT.svg": "1139",
	"./BV.svg": "83bf",
	"./BW.svg": "3f4a",
	"./BY.svg": "8358",
	"./BZ.svg": "8b4e",
	"./CA.svg": "7f78",
	"./CC.svg": "7520",
	"./CD.svg": "a963",
	"./CF.svg": "8fd8",
	"./CG.svg": "0fbb",
	"./CH.svg": "a0c6",
	"./CI.svg": "109c",
	"./CK.svg": "80d6",
	"./CL.svg": "707b",
	"./CM.svg": "93ab",
	"./CN.svg": "73dd",
	"./CO.svg": "b564",
	"./CR.svg": "9015",
	"./CU.svg": "e62d",
	"./CV.svg": "167e",
	"./CW.svg": "647c",
	"./CX.svg": "7e7b",
	"./CY.svg": "d093",
	"./CZ.svg": "7d34",
	"./DE.svg": "431c",
	"./DJ.svg": "fa16",
	"./DK.svg": "a08b",
	"./DM.svg": "f4c4",
	"./DO.svg": "c975",
	"./DZ.svg": "6876",
	"./EC.svg": "342b",
	"./EE.svg": "cf8e",
	"./EG.svg": "1893",
	"./EH.svg": "0e02",
	"./ER.svg": "7585",
	"./ES.svg": "6b6d",
	"./ET.svg": "8b44",
	"./EU.svg": "7f81",
	"./FI.svg": "11392",
	"./FJ.svg": "65f8",
	"./FK.svg": "326a",
	"./FM.svg": "d8fb",
	"./FO.svg": "264e",
	"./FR.svg": "043e",
	"./GA.svg": "8b23",
	"./GB.svg": "c1b7",
	"./GD.svg": "eed2",
	"./GE.svg": "7ea8",
	"./GF.svg": "21c8",
	"./GG.svg": "eeab",
	"./GH.svg": "a693",
	"./GI.svg": "ab85",
	"./GL.svg": "5b0d",
	"./GM.svg": "86c6",
	"./GN.svg": "7b5d",
	"./GP.svg": "e9e3",
	"./GQ.svg": "f81b",
	"./GR.svg": "57ed",
	"./GS.svg": "7f09",
	"./GT.svg": "eb16",
	"./GU.svg": "612a",
	"./GW.svg": "3c05",
	"./GY.svg": "7274",
	"./HK.svg": "884b",
	"./HM.svg": "67a3",
	"./HN.svg": "b735",
	"./HR.svg": "fc80",
	"./HT.svg": "ee35",
	"./HU.svg": "a299",
	"./ID.svg": "6dea",
	"./IE.svg": "899d",
	"./IL.svg": "5f50",
	"./IM.svg": "e88f",
	"./IN.svg": "06a4",
	"./IO.svg": "af67",
	"./IQ.svg": "42b1",
	"./IR.svg": "8df6",
	"./IS.svg": "a393",
	"./IT.svg": "5597",
	"./JE.svg": "f486",
	"./JM.svg": "b7bd",
	"./JO.svg": "20c1",
	"./JP.svg": "71569",
	"./KE.svg": "32a1",
	"./KG.svg": "efd2",
	"./KH.svg": "cbfd",
	"./KI.svg": "0111",
	"./KM.svg": "4754",
	"./KN.svg": "7bb5",
	"./KP.svg": "9a0b",
	"./KR.svg": "c25c",
	"./KW.svg": "6f59",
	"./KY.svg": "c0ee",
	"./KZ.svg": "a65d",
	"./LA.svg": "d90a",
	"./LB.svg": "bb4c",
	"./LC.svg": "2000",
	"./LI.svg": "278d",
	"./LK.svg": "4c33",
	"./LR.svg": "d789",
	"./LS.svg": "dc63",
	"./LT.svg": "f673",
	"./LU.svg": "fdee",
	"./LV.svg": "6841",
	"./LY.svg": "9f8b",
	"./MA.svg": "b10d",
	"./MC.svg": "de07",
	"./MD.svg": "a008",
	"./ME.svg": "8af7",
	"./MF.svg": "a2b0",
	"./MG.svg": "bdac",
	"./MH.svg": "ae14",
	"./MK.svg": "9d73",
	"./ML.svg": "65b6",
	"./MM.svg": "9658",
	"./MN.svg": "d7cf",
	"./MO.svg": "5aac",
	"./MP.svg": "cdcf",
	"./MQ.svg": "35f0",
	"./MR.svg": "04f2",
	"./MS.svg": "098e",
	"./MT.svg": "142d",
	"./MU.svg": "15b6",
	"./MV.svg": "920f",
	"./MW.svg": "42ba",
	"./MX.svg": "1b3b",
	"./MY.svg": "ebd0",
	"./MZ.svg": "c059",
	"./NA.svg": "4225",
	"./NC.svg": "542e",
	"./NE.svg": "15a7",
	"./NF.svg": "25a1",
	"./NG.svg": "8a01",
	"./NI.svg": "eb80",
	"./NL.svg": "130d",
	"./NO.svg": "ce0b",
	"./NP.svg": "4b27",
	"./NR.svg": "8ac1",
	"./NU.svg": "4bf9",
	"./NZ.svg": "ecdc",
	"./OM.svg": "ecad",
	"./PA.svg": "c6bf",
	"./PE.svg": "1439",
	"./PF.svg": "2c34",
	"./PG.svg": "744c",
	"./PH.svg": "0c46",
	"./PK.svg": "40a3",
	"./PL.svg": "f713",
	"./PM.svg": "a9ed",
	"./PN.svg": "58b0",
	"./PR.svg": "3268",
	"./PS.svg": "39d6",
	"./PT.svg": "a3ff",
	"./PW.svg": "c2da",
	"./PY.svg": "1413",
	"./QA.svg": "24e1",
	"./RE.svg": "b499",
	"./RO.svg": "977c",
	"./RS.svg": "73bc",
	"./RU.svg": "a2ce",
	"./RW.svg": "5d17",
	"./SA.svg": "d265",
	"./SB.svg": "755f",
	"./SC.svg": "6f97",
	"./SD.svg": "2667",
	"./SE.svg": "58f8",
	"./SG.svg": "2c37",
	"./SH.svg": "8d95",
	"./SI.svg": "b07b",
	"./SJ.svg": "c01d",
	"./SK.svg": "4dc4",
	"./SL.svg": "cfd3",
	"./SM.svg": "20ea",
	"./SN.svg": "7bd1",
	"./SO.svg": "3dbe",
	"./SR.svg": "29ef",
	"./SS.svg": "cb4b",
	"./ST.svg": "6253",
	"./SV.svg": "ca51",
	"./SX.svg": "210c",
	"./SY.svg": "b2a6",
	"./SZ.svg": "78a3",
	"./TC.svg": "c766",
	"./TD.svg": "24b8",
	"./TF.svg": "6fdb",
	"./TG.svg": "327d",
	"./TH.svg": "90e4",
	"./TJ.svg": "f65d",
	"./TK.svg": "d436",
	"./TL.svg": "7517",
	"./TM.svg": "4d04",
	"./TN.svg": "33f8",
	"./TO.svg": "2b0f",
	"./TR.svg": "fe3c",
	"./TT.svg": "c924",
	"./TV.svg": "3248",
	"./TW.svg": "2c35",
	"./TZ.svg": "efc5",
	"./UA.svg": "1242",
	"./UG.svg": "2189",
	"./UM.svg": "54fc",
	"./US.svg": "dd1e",
	"./UY.svg": "80fe",
	"./UZ.svg": "2491",
	"./VA.svg": "e93c",
	"./VC.svg": "7640",
	"./VE.svg": "2acc",
	"./VG.svg": "eee2",
	"./VI.svg": "669a",
	"./VN.svg": "a2e4",
	"./VU.svg": "940b",
	"./WF.svg": "42da",
	"./WS.svg": "94ed",
	"./YE.svg": "e359",
	"./YT.svg": "a895",
	"./ZA.svg": "60d4",
	"./ZM.svg": "141e",
	"./ZW.svg": "9184",
	"./pirate.svg": "9275",
	"./rainbow.svg": "a915",
	"./trans.svg": "b26f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7014";